import React from 'react';

const Logo = () => (
  <svg
    width="71"
    height="32"
    viewBox="0 0 71 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.27287 8.76318H0.476013V30.5766H4.27287V8.76318Z"
      fill="#363636"
    />
    <path
      d="M27.1668 12.2847C25.4136 9.71209 22.2441 8.31689 19.1505 8.31689C12.96 8.31689 8.03897 13.1638 8.03897 19.6897C8.03897 26.1786 13.0359 31.0255 19.1505 31.0255C20.6796 31.0255 22.1715 30.6529 23.6248 29.9448C25.1168 29.2367 26.3087 28.2883 27.1668 26.9834V30.5787H30.833V8.76368H27.1668V12.2847ZM19.1908 27.3012C15.0665 27.3012 11.7536 23.9172 11.7536 19.6526C11.7536 15.4219 15.0665 12.0041 19.1908 12.0041C23.42 12.0041 26.6991 15.4235 26.6991 19.6526C26.6991 23.9172 23.42 27.3012 19.1908 27.3012Z"
      fill="#363636"
    />
    <path
      d="M61.5386 8.23633C57.6433 8.23633 54.982 9.63313 53.6271 12.388C52.3319 9.82185 49.3754 8.23633 45.8656 8.23633C42.8865 8.23633 40.6203 9.23312 39.2945 11.1219V8.68311H35.5315V30.6578H39.3316V18.7979C39.3316 14.3832 41.8171 11.53 45.664 11.53C49.2044 11.53 51.5819 13.8655 51.5819 17.3414V30.6594H55.29V18.1414C55.29 16.1091 55.9771 14.3236 57.2256 13.1171C58.3385 12.0413 59.845 11.4783 61.4708 11.5316C65.137 11.6525 67.3242 13.951 67.3242 17.6785V30.661H71.0001V17.7156C71.0001 14.9091 70.1065 12.53 68.4161 10.8348C66.7274 9.13312 64.3467 8.23633 61.5386 8.23633Z"
      fill="#363636"
    />
    <path
      d="M2.37425 0.974609C1.06293 0.974609 0 2.03754 0 3.34886C0 4.66018 1.06293 5.7231 2.37425 5.7231C3.68557 5.7231 4.74849 4.66018 4.74849 3.34886C4.74688 2.03754 3.68395 0.974609 2.37425 0.974609Z"
      fill="#363636"
    />
  </svg>
);

export default Logo;
